import Vue from 'vue'

export default {
    recuperarSituacoesProcesso(){
        return Vue.axios
            .get("situacaoProcesso")
    }
}